import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';

import { AuthFacadeService, AuthRestartService, OAuthService } from 'app/shared/services';

export const authInterceptor: HttpInterceptorFn =
    (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
        if (req.url.includes('/api/oauth/authorize')
            || req.url.includes('/api/oauth/token')
            || req.url.includes('/config/')
            || req.url.includes('/i18n/')) {
            return next(req);
        }

        const authFacade = inject(AuthFacadeService);
        const authRestart = inject(AuthRestartService);
        const oauthService = inject(OAuthService);

        return authFacade.getValidAccessToken$()
            .pipe(
                catchError(() => {
                    authRestart.restartAuthorization();
                    return EMPTY;
                }),
                switchMap((accessToken: string) =>
                    next(withBearer(req, accessToken)).pipe(
                        catchError((err) => {
                            if (!(err instanceof HttpErrorResponse) || err.status !== 401) {
                                return throwError(() => err);
                            }

                            return oauthService.refresh$()
                            .pipe(
                                take(1),
                                switchMap((bearer) => next(withBearer(req, bearer.access_token))),
                                catchError(() => {
                                    authRestart.restartAuthorization();
                                    return EMPTY;
                                }),
                            );
                        }),
                    ),
                ),
            );
    };

function withBearer(req: HttpRequest<unknown>, accessToken: string): HttpRequest<unknown> {
    return req.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } });
}
